/*
 * @Author: zyq
 * @Date: 2022-10-19 09:57:01
 * @LastEditors: zyq
 * @LastEditTime: 2022-10-25 22:12:58
 * @description:
 */
import axios from 'axios'
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  // baseURL: 'http://192.168.31.254:8001',
  baseURL: '/api',
  timeout: 20000 // 请求超时时间
  // withCredentials: false,//允许携带cookie
})
// 请求头配置
service.defaults.headers['Content-Type'] = 'application/json;UTF-8'

// request拦截器
service.interceptors.request.use(
  config => {
    config.headers.token = getToken()
    return config
  },
  error => {
    Promise.reject(error).then()
  }
)

// response 拦截器
service.interceptors.response.use(
  // Message.destroyAll(),
  response => {
    const res = response.data

    console.log('service.res', res)
    // 失败状态
    if (!res.success) {
      // 可继续进行判断
      if (res.errorMessage !== '') {
        Message.closeAll()
        Message({
          showClose: true,
          message: res.errorMessage,
          type: 'error',
          duration: 3 * 1000
        })
      }
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  (error) => {
    // axios 实际上已经做了处理
    let content = '系统正在维护中'
    switch (error.code) {
      case 'ERR_NETWORK':
        // 断网
        content = '网络错误，请检查网络连接后重试'
        break
      case 'ECONNABORTED':
        // axios 请求超时
        content = '请求超时'
        break

      case 'ERR_BAD_RESPONSE':
      case 'ERR_BAD_REQUEST':
        // 后端没开
        content = '系统正在维护中'
        break
      default:
        content = '系统正在维护中'
    }
    Message.closeAll()
    // 可继续进行判断
    Message({
      showClose: true,
      message: content,
      type: 'error',
      duration: 3 * 1000
    })
    console.error('axios.error.res => ', error.message, error)
    return Promise.reject(Object.assign(error, { msgContent: content }))
  }
)

export default service
